var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0.28006C12.6665 0.28006 5.5627 4.56583 0.320804 11.5271C-0.106935 12.0974 -0.106935 12.8942 0.320804 13.4645C5.5627 20.4341 12.6665 24.7199 20.5 24.7199C28.3335 24.7199 35.4373 20.4341 40.6792 13.4729C41.1069 12.9025 41.1069 12.1058 40.6792 11.5355C35.4373 4.56583 28.3335 0.28006 20.5 0.28006ZM21.0619 21.1051C15.862 21.4321 11.5678 17.1464 11.8949 11.938C12.1633 7.64387 15.6439 4.16325 19.9381 3.89487C25.138 3.56778 29.4322 7.85355 29.1051 13.0619C28.8283 17.3477 25.3477 20.8283 21.0619 21.1051ZM20.8019 17.1296C18.0007 17.3057 15.6858 14.9993 15.8704 12.198C16.0129 9.88321 17.8916 8.0129 20.2065 7.86193C23.0077 7.68581 25.3225 9.99224 25.138 12.7935C24.9871 15.1167 23.1084 16.987 20.8019 17.1296Z",
    fill: "#ACBEC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.6782b231.svg";
export { ForwardRef as ReactComponent };